<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-16T09:16:14+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-16T14:08:04+02:00
@Copyright: Diversitude 2022
-->



<template>
    <Layout>
        <!--<PageHeader :title="title" :items="items" />-->
        <b-row>
            <!-- left menu -->
            <b-col xl="2" sm="3">
                <Menu @back="backEvent"/>
                <!-- <Menu @back="handleBack"/> -->
            </b-col>

            <!-- main content -->
            <b-col xl="10" sm="9">
                <b-col cols="12">
                    <!-- <StatusHeader v-if="show_form == false"/> -->
                    <TimelineTable v-if="show_form == false" @selectedRow="selectedRow"/>


                    <!-- Display selected step form -->
                    <div class="card" v-if="show_form && step_data != null">
                        <StepProgress v-if="show_form" @back="backEvent" />
                        <b-tabs v-model="tab_index" nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                            <b-tab active>
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-home"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{formTab}}</span>
                                </template>
                                <div class="card-body tabBody">
                                    <div v-if="step_data.render_type == 'custom'">
                                        <component @back="backEvent" v-if="show_form" :is="stepComponent"/>
                                    </div>
                                    <div v-else-if="step_data.render_type == 'simple'">
                                        <component  @back="backEvent" v-if="show_form" :is="stepComponent"/>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab>
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-user"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{commentTab}}</span>
                                </template>
                                <div class="card-body tabBody">
                                    <Chat />
                                </div>
                            </b-tab>

                            <b-tab>
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{validationTab}}</span>
                                </template>
                                <div class="card-body tabBody" style="min-height: unset !important;">
                                    <StepValidation :admin="false" />
                                </div>
                            </b-tab>

                            <b-tab v-if="hasMedia">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-cog"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{mediaTab}}</span>
                                </template>
                                <div class="card-body tabBody">
                                    <Media />
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </b-col>
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main-stripped";
//eslint-disable-next-line
import PageHeader from "@/components/page-header";

import StepProgress from '@/components/client/pre-inspection/progress.vue'

import StatusHeader from '@/components/client/pre-inspection/statusBar.vue'
import TimelineTable from '@/components/client/pre-inspection/timelineTable.vue'

import { licenseAppState, licenseAppMethods, layoutMethods } from '@/state/helpers'

import Chat from '@/components/client/pre-inspection/containerTabs/chat.vue';
import StepValidation from '@/components/client/pre-inspection/containerTabs/stepValidation.vue';
import Media from '@/components/client/pre-inspection/containerTabs/media.vue';
import Menu from '@/components/widgets/green-menu.vue'
//import _ from 'lodash'
export default {
    data:() => ({
        steps:[],
        show_form: false,
        tab_index: 0,
    }),
    components:{
        StatusHeader,
        TimelineTable,
        Layout,
        Chat,
        StepValidation,
        StepProgress,
        Media,
        Menu,
    },
    computed:{
        ...licenseAppState,
        stepComponent() {
            if(this.step_data.render_type == 'simple'){
                return () => import(`../../../components/client/renderComponents/Simple`);
            }
            else{
                let data = this.step_data.custom_render_component_name;
                //if(data == 'form-plugin'){
                    //return data;
                //}
                //else{
                return () => import(`../../../components/client/renderComponents/${data}`);
                //}
            }

        },

        hasMedia(){
            let show = false;
            if(this.step_data != null){
                if(this.step_data.media.length > 0){
                    show = true;
                }
            }
            return show;
        },




        /* Tab names */
        formTab(){
            //TODO add totals to title
            return 'Form'
        },
        commentTab(){
            //TODO add totals to title
            return 'Comments'
        },
        validationTab(){
            //TODO add totals to title
            return 'Validation'
        },
        mediaTab(){
            //TODO add totals to title
            return 'Media'
        }
    },
    methods:{
        ...layoutMethods,
        ...licenseAppMethods,
        selectedRow(id){
            console.log('Row -> '+ id);
            //if valid row
            this.show_form = true;
        },
        formSaved(){
            this.show_form = false;
        },
        backEvent(id = null){
            //* Select table row if id is valid
            this.show_form = false;
            if(id != null){
                this.$nextTick(()=>{
                    this.loadAppData()
                    .then(()=>{
                        setTimeout(()=>{
                            //eslint-disable-next-line
                            let table = $$('clientStepsTable');
                            if(table != undefined){
                                this.$nextTick(()=>{
                                    table.select(id);
                                })
                            }
                        }, 150)

                    })
                })

            }
        },
        showFormTab(){
            this.tab_index = 0;
        }
    },
    mounted(){
        if(this.app_data == null){
            this.loadAppData()
            /*.then(()=>{
                this.steps = _.cloneDeep(this.step_data.spreadify_views);
            })*/
        }
        /*if(this.step_data != null && this.app_data != null){
            this.steps = _.cloneDeep(this.step_data.spreadify_views);
        }*/
        this.$eventHub.$on('savedFormData', this.formSaved);
        this.$eventHub.$on('showFormTab', this.showFormTab);

        this.updateMenuType({
            type: 'client_application',
            showRoutes: true,
            showMenu: true,
        })
    },
    beforeDestroy(){
        this.$eventHub.$off('savedFormData');
        this.$eventHub.$off('showFormTab');
    }
}
</script>

<style>

</style>
